<template>
  <div class="overlay-wrap">
    <div class="overlay-container" @click="$emit('click', $event)"> </div>

    <div class="overlay">
      <slot></slot>
    </div>
  </div>
</template>

<script>
// 弹窗的深色背景层
export default {
  name: 'Overlay',
  props: {
    lockScroll: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    lockScroll: {
      handler(val) {
        document.body.style.overflow = val ? 'hidden' : '';
      },
      immediate: true
    }
  },
  beforeDestroy() {
    if (this.lockScroll) {
      document.body.style.overflow = '';
    }
  }
};
</script>
